<template>
  <div class="ohs-request-display">
    <div class="card card-default mb-4">
      <h4
        class="card-header"
        v-html="title" />
      <div class="card-body">
        <p 
          class="text-danger"
          v-if="!esmReport.complete">
          <i class="fa fa-exclamation-triangle" /> Report Incomplete
        </p>
        <p class="text-muted" v-if="esmReport.StaffMember">
          {{ esmReport.StaffMember.fullName }} - <i class="far fa-clock fa-fw" /> {{ esmReport.createdAt | date_time_format }}
          <span class="float-right" v-if="$user.administrator"><i class="fas fa-stopwatch fa-fw" /> Time spent: {{ timeSpent }}</span>
        </p>
        <template v-if="esmReport.TaxInvoiceRequest">
          <p>
            <strong>
              Tax Invoice Request
            </strong>
            <br>
            <download-input
              :options="{ label: esmReport.TaxInvoiceRequest.referenceNumber, permalink: 'downloadFile'}"
              :value="{ objectKey: esmReport.TaxInvoiceRequest.InvoiceRequestPdf.objectKey }" />
          </p>
          <p v-if="esmReport.TaxInvoiceRequest.UploadedInvoice">
            <strong>
              Uploaded Invoice
            </strong>
            <br>
            <download-input
              :options="{ label: esmReport.TaxInvoiceRequest.UploadedInvoice.fileName, permalink: 'downloadFile'}"
              :value="{ objectKey: esmReport.TaxInvoiceRequest.UploadedInvoice.objectKey }" />
          </p>
        </template>
        <template v-if="esmReport.SentEmails.length">
          <sent-email
            v-for="email in esmReport.SentEmails"
            :key="email.uuid"
            :email="email">
          </sent-email>
        </template>
      </div>
      <div class="card-footer">
        <router-link
          :to="{ path: 'edit/' + esmReport.uuid, append: true }"
          class="my-1 btn btn-black">
          <i class="far fa-fw fa-edit" /> Edit
        </router-link>
        <router-link
          target="_blank"
          :to="{ path: '/api/public/pdf/' + esmReport.uuid + '?m=EsmReport' }"
          class="my-1 btn btn-secondary"
          :class="{ 'disabled': !esmReport.ReportPdfUuid }">
          <i class="fa fa-fw fa-search" /> Preview
        </router-link>
        <download-input
          :disabled="!esmReport.ReportPdfUuid"
          :options="{ button: true, permalink: 'downloadFile'}"
          :value="{ objectKey: esmReport.ReportPdf ? esmReport.ReportPdf.objectKey : '' }" />
        <button 
          class="my-1 btn btn-primary" 
          @click="generatePdf()">
          <i class="fa fa-fw fa-redo-alt" /> Generate PDF
        </button>
        <button 
          class="my-1 btn btn-success" 
          @click="send()" 
          :disabled="!esmReport.complete">
          <i class="far fa-fw fa-paper-plane" /> Send
        </button>
        <button 
          class="my-1 btn btn-lime" 
          @click="duplicate()">
          <i class="far fa-fw fa-copy" /> Duplicate
        </button>
        <router-link 
          :to="'/tax-invoice-requests/new/' + esmReport.uuid + '?t=EsmReport'"
          class="my-1 btn btn-warning"
          :class="{ 'disabled': !generateInvoiceButton }">
          <i class="fa fa-fw fa-dollar-sign" /> Invoice Request
        </router-link>
        <button 
          @click="deleteEsmReport()" 
          class="my-1 btn btn-danger">
          <i class="fa fa-fw fa-trash" /> Delete
        </button>
      </div>
    </div>
  </div>
</template>
<script>
  import {
    DELETE_REPORT,
    DUPLICATE_ESM_REPORT,
    GENERATE_ESM_PDF,
    SEND_ESM_REPORT
  } from '@/vuex/types'
  import SentEmail from '@/components/displays/SentEmail'
  import DownloadInput from '@/components/inputs/DownloadInput'
  export default {
    name: 'EsmReportDisplay',
    props: {
      object: {
        type: Object,
        default () {
          return {}
        }
      }
    },
    components: {
      SentEmail,
      DownloadInput
    },
    computed: {
      timeSpent () {
        let minutes = this.esmReport.time / 60.0
        if (minutes > 120) {
          let hours = minutes / 60
          return hours.toFixed(2) + ' hours'
        } else {
          return minutes.toFixed(2) + ' min'
        }
      },
      fileName () {
        if (this.esmReport.ReportPdf) {
          return this.esmReport.ReportPdf.fileName.slice(0, -4)
        } else {
          return this.esmReport.propertyAddress
        }
      },
      generateInvoiceButton () {
        return this.esmReport.complete && !this.esmReport.TaxInvoiceRequestUuid
      },
      title () {
        if (this.esmReport.propertyAddress) {
          return '<i class="fa fa-fw fa-map-marker-alt"></i> ' + this.esmReport.propertyAddress
        } else {
          return '<i class="fa fa-fw fa-certificate"></i> New Report'
        }
      },
      esmReport () {
        return {
          StaffMember: {},
          ...this.object
        }
      }
    },
    methods: {
      async deleteEsmReport () {
        await this.$store.dispatch(DELETE_REPORT, {
          reportUuid: this.esmReport.uuid,
          reportType: 'EsmReport'
        })
      },
      async generatePdf () {
        await this.$store.dispatch(GENERATE_ESM_PDF, this.esmReport)
      },
      async duplicate () {
        await this.$store.dispatch(DUPLICATE_ESM_REPORT, this.esmReport.uuid)
      },
      async send () {
        await this.$store.dispatch(SEND_ESM_REPORT, this.esmReport.uuid)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/cards/EsmReport.vue